export default "__VITE_ASSET__D9Ur04cM__"